<template>
  <div class="full-screen" style="z-index: 10">
    <!-- <div class="header-nav">
      <div class="left">
        <a class="lk-back" @click="returnPage">返回</a>
      </div>
    </div> -->
    <div class="topbar flex">
      <div class="fl">
        <a @click="returnPage">
          <i class="fa-angle-left"></i>
        </a>
      </div>
      <div class="span-title">修改密码</div>
      <a class="lk-home" @click="returnHome">
        <i class="fa-home"></i>
      </a>
    </div>


    <div class="login">
      <ul>
        <li>
          <label>设置新密码</label>
          <div><input v-model="pwd" class="inp" type="password" placeholder="请输入新密码"/></div>
        </li>
        <li>
          <label>确认信密码</label>
          <div><input v-model="confirmPwd" class="inp" type="password" placeholder="请输入密码"/></div>
        </li>
      </ul>

      <!-- 下面是错误提示 -->
      <div v-if="errorMsg.show" class="text-red">{{errorMsg.msg}}</div>
      <div class="btnbox">
        <button type="button" class="btn" @click="validate">确定</button>
      </div>
    </div>

    <div id="confirm-modal" v-if="showModal" class="fixed-confirm" style="display: block;">
      <div class="fixed-c">
        <h3>{{changed ? '密码更新成功' : '密码更新失败，请稍后重试'}}</h3>
        <div class="btnbox">
          <button class="btn" type="button" @click="hideModal">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import userService from "../../../services/userService";

  export default {
    name: "change-password",
    data() {
      return {
        pwd: '',
        confirmPwd: '',
        errorMsg: {
          show: false,
          msg: ''
        },
        showModal: false,
        changed: true
      }
    },
    methods: {
      returnPage() {
        this.$router.isBack = true;
        this.$router.go(-1);
      },
      returnHome() {
        this.$router.isBack = false;
        this.$router.push('/home');
      },
      validate() {
        if (this.pwd === '') {
          this.errorMsg = {show: true, msg: '请输入密码'}
        } else if (this.confirmPwd === '') {
          this.errorMsg = {show: true, msg: '请确认密码'}
        } else if (this.pwd !== this.confirmPwd) {
          this.errorMsg = {show: true, msg: '密码不一致，请确认'}
        } else {
          this.errorMsg = {show: false, msg: ''};
          this.changePwd();
        }
      },
      changePwd() {
        userService.changePwd(this.pwd)
          .then(res => {
            if (res.result) {
              userService.updateUserInfo();
              this.changed = true;
              this.showModal = true;
            } else {
              this.errorMsg = {show: true, msg: res.msg}
            }
          })
      },
      hideModal() {
        let obj = document.getElementById('confirm-modal');
        obj.style.opacity = 1;
        this.slideOut(obj);
      },
      slideOut(obj) {
        obj.style.opacity -= 0.05;
        if (obj.style.opacity > 0) {
          setTimeout(() => {
            this.slideOut(obj)
          }, 15)
        } else {
          this.showModal = false;
          this.$router.isBack = true;
          this.$router.go(-1);
        }
      }
    },
    mounted() {
      this.$router.isBack = true;
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/layer2/user/change-password.vue